import {
  getCurrentJobMonths,
  getTotalExperience,
} from "../services/utilService";
import { experiences, educationTimeline } from "./experience.js";
import { profile } from "./profile.js";

export const allExperiences = [
  // Job roles: map the shared shape to the timeline shape. The current role shows
  // a live month count; a role with a note (e.g. "Part-time") appends it.
  ...experiences.map((exp) => ({
    title: exp.position,
    company: exp.company,
    companyLink: exp.companyLink,
    description: exp.description,
    tenure: exp.date.endsWith("Present")
      ? `${exp.date} (${getCurrentJobMonths()} months)`
      : exp.note
      ? `${exp.date} (${exp.note})`
      : exp.date,
  })),
  // Education entry (with icon)
  {
    ...educationTimeline,
    icon: "/assets/education.svg",
  },
];

export const landing = {
  name: profile.name.toUpperCase(),
  title: ["FULL STACK ENGINEER", "AI ENGINEER", "FRONT END ENGINEER", "BACK END ENGINEER"],
  intro: (
    <>
      <h6 className="mt-5 mb-0 fw-normal lh-2 text-center-before-lg">
        Senior Software Engineer with {getTotalExperience(0.5)} building
        full-stack applications and production AI agents across fintech,
        aviation, logistics, and healthcare industries globally.
      </h6>
      <h6 className="mb-0 fw-normal lh-2 text-center-before-lg">
        Experienced in platform engineering, LLM integration, and cloud-native
        microservices architecture.
      </h6>
      <h6 className="mb-0 fw-normal lh-2 text-center-before-lg">
        Specializes in test-driven development, scalable distributed systems,
        and delivering measurable impact in high-traffic production environments.
      </h6>
    </>
  ),
};

export const recommendations = [
  "/assets/recommendations/recommendation-1.png",
  "/assets/recommendations/recommendation-2.png",
  "/assets/recommendations/recommendation-3.png",
  "/assets/recommendations/recommendation-4.png",
  "/assets/recommendations/recommendation-5.png",
];
